export default "__VITE_ASSET__C$G_zwtb__"